import { t } from 'i18next';
import { z } from 'zod';
import { InputRegexMap, OnboardingFormFields } from '@Types/index.ts';
import { ControlledTextInput } from './ControlledInputs';

export const MAX_CITY_CHARS = 30;

interface IProps {
  disabled?: boolean;
  tabIndex?: number;
}

export const CityInput = ({ disabled = false, tabIndex }: IProps) => {
  return (
    <ControlledTextInput
      name={OnboardingFormFields.CITY}
      title={t('pages.homeAddress.cityFieldTitle')}
      id={OnboardingFormFields.CITY}
      disabled={disabled}
      tabindex={tabIndex}
      isPublic={false}
    />
  );
};

export const citySchema = z.object({
  [OnboardingFormFields.CITY]: z
    .string()
    .min(1, t('enErrors:required'))
    .min(2, t('enErrors:address.city.min'))
    .max(
      MAX_CITY_CHARS,
      t('enErrors:address.city.max', {
        max: MAX_CITY_CHARS,
      })
    )
    .regex(InputRegexMap.cityUS, t('enErrors:address.city.invalid')),
});
